/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log(
	'Hello World! (from schmucki-agenturschmucki-employee-accordion block)'
);
/* eslint-enable no-console */
document.querySelectorAll(".accordion-item").forEach((detail) => {
    const content = detail.querySelector("ul");
	console.log("content: ", content);
    const summary = detail.querySelector("summary");
	console.log("summary: ", summary);

    detail.addEventListener("toggle", () => {
        if (detail.open) {
            // Berechne die dynamische Höhe beim Öffnen
            
            // const paddingTopContent = parseFloat(window.getComputedStyle(content).paddingTop);
            // const paddingBottomContent = parseFloat(window.getComputedStyle(content).paddingBottom);

            // const paddingTopSummary = parseFloat(window.getComputedStyle(summary).paddingTop);
            // const paddingBottomSummary = parseFloat(window.getComputedStyle(summary).paddingBottom);
			
            const totalHeight = content.clientHeight + summary.clientHeight;
			console.log("totalHeight: ", totalHeight);

            // Setze die CSS-Variable
            detail.style.setProperty("--content-height", `${totalHeight}px`);

            // Schließe andere offene Akkordeons
            document.querySelectorAll(".accordion-item").forEach((otherDetail) => {
                if (otherDetail !== detail && otherDetail.open) {
                    otherDetail.open = false;
                }
            });
        } else {
            // Beim Schließen kann die Höhe direkt auf 0 gesetzt werden, damit die Transition angewendet wird
            detail.style.setProperty("--content-height", `0px`);
        }
    });
});